import React, { useEffect } from "react";
import history from "history/browser";
import { useAuthState } from "../context/AuthContext";
import SplashPage from "../pages/SplashPage";
import { Navigate, useNavigate } from "react-router-dom";

const HwGuard = ({ Component }) => {

    const { authenticated, loading, user } = useAuthState();
    const navigate = useNavigate();
    const qr = localStorage.getItem('qr');
    let location = String(history.location.pathname);
    
    useEffect(() => {
        if (location && !loading && authenticated === false) {
            const safePath = location.replaceAll("/", "_");
            navigate(`/next/${safePath}`);
        }
    }, [authenticated, loading, location, navigate])

    if (loading) {
        return (
            <SplashPage />
        );
    }

    return authenticated && user.x_is_house_management? 
        <Component /> : 
        <Navigate to={qr? `/qr/${qr}`: `/`} />
};

export default HwGuard;